import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themetwo/dayList.png'


const _hoisted_1 = { class: "cardContainer" }
const _hoisted_2 = { class: "dayCard" }
const _hoisted_3 = { class: "dayImage" }
const _hoisted_4 = { class: "day-num" }
const _hoisted_5 = { class: "availableTitle" }
const _hoisted_6 = { class: "availableTitle" }
const _hoisted_7 = { class: "givenValueText" }

import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashBackCard',
  props: {
    showClickButton: {
        type: Boolean,
    },
    availableValue: {
        type: Number,
        default: () => 0
    },
    givenValue: {
        type: Number,
        default: () => 0
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => getDefaultRewards()
    },
    createDate: {
        type: String,
        default: () => ""
    },
},
  emits: ['getClaim'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const clickOnButton = () => {
    emits('getClaim')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "24",
          class: "dayRow"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, {
              style: {"width":"100%"},
              justify: "center"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayList, (i, index) => {
                  return (_openBlock(), _createBlock(_component_van_col, {
                    span: "4",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _cache[0] || (_cache[0] = _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)),
                          _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "dateText",
                          style: _normalizeStyle({ color: index == 0 && __props.showClickButton ? '#36d836' : index == 0 && !__props.showClickButton ? 'gray' : '' })
                        }, _toDisplayString(_unref(dayFormat)(i.date, 0)), 5),
                        _createElementVNode("div", {
                          class: "dateText",
                          style: _normalizeStyle({ color: index == 0 && __props.showClickButton ? '#36d836' : index == 0 && !__props.showClickButton ? 'gray' : '' })
                        }, _toDisplayString(_unref(formatCurrency)(i.amount)), 5)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "24",
          class: "availbleContent"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('activity.available')), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString('R$ ' + _unref(formatCurrency)(__props.availableValue)), 1),
            (props.showClickButton)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "click_btn",
                  onClick: clickOnButton
                }, _toDisplayString(_ctx.$t('activity.click')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('activity.given')) + " " + _toDisplayString(_unref(formatCurrency)(__props.givenValue)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})